(() => {
  class MailOrderStatusUpdateController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, Orders, Messages, Users, Auth, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Orders,
        Messages,
        Users,
        Auth,
        $state,
        ngDialog,
        mailordervisit: $scope.ngDialogData.visit,
        messages: [],
        beforeCursor: null,
        afterCursor: null,
        POLL_INTERVAL: 5000
      });
    }

    close() {
      this.$scope.closeThisDialog();
    }

    updateMailOrderStatus() {
      console.log(this.mailordervisit);
      var this2 = this;
      this.Orders.updateMailOrderStatus(this.mailordervisit.mail_order_id, this.mailordervisit.id).then(({}) => {
        this2.toastr.error('success: cancelled');
        this.$scope.closeThisDialog();
      }).catch(() => this.toastr.error(this.Notifications.generic.failure)).finally(() => {
        this.loading = false;
      });
      this.$scope.closeThisDialog();
    }

  }

  MailOrderStatusUpdateController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "Orders", "Messages", "Users", "Auth", "$state", "ngDialog"];
  angular.module('pims').controller('MailOrderStatusUpdateController', MailOrderStatusUpdateController);
})();